import { tViews } from "../../../utils/table";
import { formatNumberNDecimalPlaces } from "../../../utils/format";
import { defaultCellValue } from "../../../utils/enums";

export const getTableColumns = () => {
  let tableColumns = [
    { 
      prop: "site_id",
      name: tViews('allSiteSiteLabel'), 
      sortable: true,
      size: 120
    },
    { 
      prop: "city",
      name: tViews('hostLocation'), 
      sortable: true,
      size: 150
    },
    { 
      prop: "tunnel_name",
      name: tViews('hostTunnelName'), 
      size: 300, 
    },
    { 
      prop: "usage",
      name: tViews('appExperienceUsage'), 
      sortable: true,
      size: 100
    },
    { 
      prop: "vqoe_score",
      name: tViews('appflowQoeScore'),
      size: 90, 
    },
    { 
      prop: "loss_percentage",
      name: tViews('app360Loss'), 
      size: 90
    },
    { 
      prop: "latency",
      name: tViews('app360Latency'), 
      size: 110
    },
    { 
      prop: "jitter",
      name: tViews('app360Jitter'), 
      size: 90
    },
    { 
      prop: "local_system_ip",
      name: tViews('app360AppFlowLocalDevice'), 
      size: 110
    },
    { 
      prop: "remote_system_ip",
      name: tViews('app360AppFlowRemoteDevice'), 
      size: 110
    },
    { 
      prop: "local_color",
      name: tViews('app360AppFlowLocalColor'), 
      size: 110
    },
    { 
      prop: "remote_color",
      name: tViews('app360AppFlowRemoteColor'), 
      size: 110
    },
  ];
   return tableColumns.map((item) => {
        let obj = {
            ...item,
            id: item.prop
        } 
        return obj;
    }); 
};

// This function is used to validate and format the number with specified decimal places
const validateAndFormatNumber = (value, decimalPlaces = 1) => {
  if (Number.isFinite(value))
    return formatNumberNDecimalPlaces(value, decimalPlaces);
  return defaultCellValue;
};

// This function is used to format the data for the application table in Circuit 360
export const setTableData = data => {
  return data.map((item) => ({
    ...item, 
    vqoe_score: validateAndFormatNumber(item.vqoe_score), 
    loss_percentage: validateAndFormatNumber(item.loss_percentage),
    latency: validateAndFormatNumber(item.latency),
    jitter: validateAndFormatNumber(item.jitter),
  }));  
};

 
